var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoBox"},[_c('p',{staticClass:"font20 mb20 fontw"},[_vm._v("课程视频")]),_vm._v(" "),_c('el-row',{staticClass:"children",attrs:{"gutter":18}},_vm._l((_vm.tableData),function(item,index){return _c('el-col',{key:index,attrs:{"span":index == 0 ? 12 : 6}},[_c('list-item',{directives:[{name:"czc",rawName:"v-czc",value:([
          '行业看点-视频',
          '点击列表',
          `全部视频列表`,
          index + 1,
          `hykdVideo-list-all`,
        ]),expression:"[\n          '行业看点-视频',\n          '点击列表',\n          `全部视频列表`,\n          index + 1,\n          `hykdVideo-list-all`,\n        ]"}],staticClass:"bacf",class:index == 0 ? 'bigVideo' : '',attrs:{"data":item,"visitlocation":'课程视频'}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }